import { render } from "./ResumenIndicadores.vue?vue&type=template&id=1b33a1c7&scoped=true"
import script from "./ResumenIndicadores.vue?vue&type=script&lang=js"
export * from "./ResumenIndicadores.vue?vue&type=script&lang=js"

import "./ResumenIndicadores.vue?vue&type=style&index=0&id=1b33a1c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b33a1c7"]])

export default __exports__